import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "align-middle inline-block w-full" }
const _hoisted_2 = { class: "overflow-x-auto border-t border-b border-gray-200" }
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_4 = { class: "bg-gray-50" }
const _hoisted_5 = ["width"]
const _hoisted_6 = {
  key: 0,
  class: "px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
}
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200 text-sm text-gray-500" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { class: "text-sm text-gray-400 py-4" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    headers: {
        type: Array
    },

    tableClass: {
        default: null,
        type: String
    },

    /* Text for empty list */
    emptyText: {
        default: 'No data to display.',
        type: String
    },

    /* Hide action column */
    noAction: {
        default: false,
        type: Boolean
    },

        /* Action header text */
    actionText: {
        default: 'Action',
        type: String
    },

    count: {
        default: 0,
        type: Number,
    },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frm-table", [ __props.tableClass ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("thead", _hoisted_4, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: `th-${index}`,
                    class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap",
                    width: header.width
                  }, _toDisplayString(header.text), 9, _hoisted_5))
                }), 128)),
                (!__props.noAction)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(__props.actionText), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_7, [
            (__props.count > 0)
              ? _renderSlot(_ctx.$slots, "body", { key: 0 })
              : (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", {
                    class: "whitespace-nowrap text-center",
                    colspan: 
                                        __props.headers.length + (!__props.noAction ? 1 : 0)
                                    
                  }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(__props.emptyText), 1)
                  ], 8, _hoisted_9)
                ]))
          ])
        ])
      ])
    ])
  ], 2))
}
}

})